import * as React from 'react';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import SearchIcon from '@mui/icons-material/Search'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment';
import { Paper } from '@mui/material';


export default function Pagenate(props: {
  onChagenPageEvent: (newPage: number) => void
}) {
  const [inputCurrentPage, setCurerntPage] = React.useState("")

  const onClick = () => {
    const pageNumber = Number(inputCurrentPage)
    if (isNaN(pageNumber)) {
      alert("数字を入力してください")
    }
    else {
      props.onChagenPageEvent(pageNumber)
    }
  }

  return (
    <React.Fragment>
      <Paper>
        <FormGroup sx={{
          alignItems: 'flex-end'
        }}>
          <FormControl sx={{ m: 1 }}
            variant="standard"
          >
            <TextField
              label="飛びたいページ番号を入力"
              variant="filled"
              color="success"
              focused
              value={inputCurrentPage}
              onChange={(event) => setCurerntPage(event.target.value)}
              onKeyPress={e => {
                if (e.key === 'Enter') {
                  onClick()
                  setCurerntPage("")
                }
              }}
              size='medium'
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton onClick={() => { onClick(); setCurerntPage("") }}>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </FormControl>
        </FormGroup>
      </Paper>
    </React.Fragment >
  );
}